import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LabProfileComponent } from './features/labs/components/lab-profile/lab-profile.component';
import { LabsComponent } from './features/labs/labs.component';
import { AuthGuard } from './helpers/auth.guard';
import { AdminLayoutComponent } from './layout/admin-layout/admin-layout.component';
import { BlankLayoutComponent } from './layout/blank-layout/blank-layout.component';
import { ErrorComponent } from './pages/error/error.component';
import { NotAuthComponent } from './pages/not-auth/not-auth.component';
import { UserProfileComponent } from './features/users/components/user-profile/user-profile.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/admin/support-ticket',
    pathMatch: 'full'
  },
  {
    path: '',
    component: BlankLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./features/auth/auth.module').then((m) => m.AuthModule),
      }
    ],
  },
  {
    path: 'admin',
    component: AdminLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'myprofile', component: UserProfileComponent },
      { path: 'notAuthorized', component: NotAuthComponent },
      {
        path: 'users',
        loadChildren: () =>
          import('./features/users/users.module').then((m) => m.UsersModule),
      },
      {
        path: 'labs',
        loadChildren: () =>
          import('./features/labs/labs.module').then((m) => m.LabsModule),
      },
      { path: 'our-labs', component: LabsComponent },
      { path: 'labProfile', component: LabProfileComponent },
      { path: 'vlProfile', component: LabProfileComponent },
      { path: 'branches/lab/:id', component: LabProfileComponent },
      {
        path: 'support-ticket',
        loadChildren: () =>
          import('./features/support-ticket/support-ticket.module').then(
            (m) => m.SupportTicketModule
          ),
        data: { preload: true }
      },
      { path: '**', component: ErrorComponent },
    ],
  },
  { path: '**', component: ErrorComponent },
  // otherwise redirect to home
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      onSameUrlNavigation: 'reload',
      // preloadingStrategy: AppCustomPreloader,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }

